import React from "react";
function GenericMessage(props) {
    return (
        <>
            <div className="text-tota bg-tota-blur mt3 mb-5 rounded mx-auto p-3" style={{ maxWidth: "350px" }}>
               {props.children}
            </div>
        </>
    );
}
export default GenericMessage;
